
  import classNames from 'classnames'
  import type { ShapeComponentType } from '../types'

  export const Blob02:ShapeComponentType = ({ className, ...props }) => {
    return <svg className={classNames('pintxo-shape', className)} {...props} width="128" height="128" viewBox="0 0 128 128" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M125.882 64C114.682 97.3333 98.4694 128 64.6575 128C30.8456 128 -12.6992 95.04 3.48674 64C24.5259 23.6533 30.8722 0 64.6842 0C98.4961 0 137.588 29.1467 125.882 64Z" fill="#0C0D0D"/>
</svg>

  }
  
